import React, { useEffect, useState } from "react";
import {
  Grid,
  Paper,
  Box,
  Container,
  Breadcrumbs,
  Typography,
  TextField,
  Card,
  CardContent,
  Button,
  Divider,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MainScreen from "../../Components/Navbar/MainScreen";
import CustomTextArea from "../../Components/CustomTextArea/CustomTextArea";
import DownloadIcon from "@mui/icons-material/Download";

import ChatGptImg from "../../Assets/IMAGES/chatgpt.png";
import TTImg from "../../Assets/IMAGES/trinidad-and-tobago.png";
import SendIcon from "@mui/icons-material/Send";
import axios from "axios";
import AXIOS from "../../Utils/AXIOS";
import toast, { Toaster } from "react-hot-toast";
import { connect } from "react-redux";

function SearchDatabaseDetails(props) {
  const [searchDbChat, setSearchDbChat] = useState([]);
  const [chatLoading, setChatLoading] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState({});

  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    setSearchDbChat([
      {
        QUESTION: location.state.AskedQuestion,
        ANSWER: location.state.AskedAnswer,
      },
    ]);
  }, []);

  const [questionInput, setQuestionInput] = useState("");

  const handleSearchDb = () => {
    if (questionInput != "") {
      let tempQuestionInput = questionInput;
      if (selectedCandidate?.candidate_id) {
        tempQuestionInput =
          tempQuestionInput +
          " Name:" +
          selectedCandidate.name +
          " Candidate_id:" +
          selectedCandidate.candidate_id;
      }
      let param = encodeURIComponent(tempQuestionInput);
     

      setChatLoading(true);
      axios
        .post(
          AXIOS.defaultURL +
            AXIOS.resume_analytics_ask +
            "?question=" +
            param,
          { question: param },
          {
            headers: {
              Authorization: `Bearer ${props.token}`,
              "x-api-key": `${props.token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          setChatLoading(false);


          setSearchDbChat([
            {
              QUESTION: questionInput,
              ANSWER: response.data,
            },
          ]);
        })
        .catch((err) => {
          setChatLoading(false);
          toast.error("Something went wrong");
        });
    } else {
      toast.error("Please enter job description");
    }
  };

  useEffect(() => {
    if (searchDbChat) {
      searchDbChat.map((val) => {

        if (val?.ANSWER?.Candidates) {
          let isCandidateFound = val.ANSWER?.Candidates.find(
            (val) => val.candidate_id == selectedCandidate.candidate_id
          );

          if (!isCandidateFound && selectedCandidate.candidate_id != null) {
            setSelectedCandidate({});
          }
        }
      });
    }
  }, [searchDbChat]);

  return (
    <MainScreen>
      <Box
        sx={{
          m: 2,
        }}
      >
        <Toaster />
        {/* <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" to="/">
            ATS++
          </Link>

          <Typography sx={{ color: "text.primary" }}>User Details</Typography>
        </Breadcrumbs> */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            // marginTop: 15,
            backgroundColor: "#fff",
            // padding: 5,
          }}
        >
          <div
            style={{
              display: "flex",
              // marginTop: 5,
            }}
          >
            <div
              className="gray-arrow-container"
              onClick={() => {
                navigate("/home");
              }}
            >
              True ATS+
            </div>
            <div
              className="gray-arrow-container"
              onClick={() => {
                navigate("/search-database");
              }}
            >
              Talent
            </div>
            <div className="blue-arrow-container">Details</div>
          </div>
        </div>
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            minHeight: "80vh", // Full viewport height
          }}
        >
          {/* Main Content Area */}
          <Grid container spacing={2} sx={{ flexGrow: 1 }}>
            {/* Left Container */}
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  mb: 1,
                  p: 0.5,
                }}
              >
                <Typography
                  sx={{
                    color: "#fd815e",
                  }}
                >
                  Details of job description
                </Typography>
              </Card>
              <Paper sx={{ padding: 2, height: "100%" }}>
                {" "}
                {searchDbChat.map((val) => {
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        mt: 1,
                      }}
                    >
                      <img
                        src={TTImg}
                        style={{
                          width: 25,
                          height: 25,
                        }}
                      />
                      <Typography
                        sx={{
                          ml: 1,
                        }}
                      >
                        {val.QUESTION}
                      </Typography>
                    </Box>
                    // <p>{val.QUESTION}</p>
                  );
                })}
              </Paper>
            </Grid>

            {/* Right Container */}
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  mb: 1,
                }}
              >
                <Typography
                  sx={{
                    color: "#14bc9a",
                    p: 0.5,
                  }}
                >
                  Details of candidates
                </Typography>
                {/* <Divider /> */}
              </Card>
              <Paper sx={{ pl: 2, pr: 2, height: "62vh", overflowY: "auto" }}>
                {searchDbChat.map((val) => {
                  return (
                    <div>
                      <Box
                        sx={{
                          display: "flex",
                        }}
                      >
                        <img
                          src={ChatGptImg}
                          style={{
                            width: 25,
                            height: 25,
                          }}
                        />
                        <Typography>{val.ANSWER.answer}</Typography>
                      </Box>
                      <Grid container spacing={2}>
                        {val.ANSWER.Candidates &&
                          val.ANSWER.Candidates.map((data, index) => (
                            <Grid item xs={12} sm={6} md={6} key={index}>
                              <Card
                                sx={{
                                  maxWidth: 300,
                                  m: 0,
                                  p: 0,
                                  boxShadow: 2,
                                  backgroundColor:
                                    selectedCandidate.candidate_id ==
                                    data.candidate_id
                                      ? "#D3ECF1"
                                      : "",
                                }}
                                onClick={() => {
                                  if (selectedCandidate?.candidate_id) {
                                    setSelectedCandidate({});
                                  } else {
                                    setSelectedCandidate(data);
                                  }
                                }}
                              >
                                <CardContent>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Typography variant="body1" gutterBottom>
                                      {data.name}
                                    </Typography>
                                    <DownloadIcon
                                      sx={{
                                        cursor: "pointer",
                                        color: "#14bc9a",
                                      }}
                                    />
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      height: 150,
                                      overflowY: "auto",
                                    }}
                                  >
                                    <Typography variant="caption">
                                      <strong> Candidate ID:</strong>{" "}
                                      {data.candidate_id}
                                    </Typography>
                                    <Typography
                                      variant="caption"
                                      sx={{ mt: 0.3 }}
                                    >
                                      <strong>Business:</strong> {data.business}
                                    </Typography>
                                    <Typography variant="caption">
                                      <strong>Experience:</strong> {data.exp}
                                    </Typography>
                                    <Typography variant="caption">
                                      <strong>Primary Skill:</strong>{" "}
                                      {data.primarySkill}
                                    </Typography>
                                    <Typography variant="caption">
                                      <strong>Technical Skills:</strong>{" "}
                                      {data.technical}
                                    </Typography>
                                  </Box>
                                </CardContent>
                              </Card>
                            </Grid>
                          ))}
                      </Grid>
                    </div>
                  );
                })}
                {/* {searchDbChat.map((val) => {
                  return <p>{val.}</p>;
                })} */}
              </Paper>
            </Grid>
          </Grid>

          {/* Sticky Bottom Container */}
          <Box sx={{ width: "100%", mt: "auto" }}>
            <Paper sx={{ pl: 2, pr: 2, display: "flex", alignItems: "center" }}>
              <CustomTextArea
                label="Ask any Question"
                multiline
                rows={4} // Number of visible rows
                fullWidth
                variant="outlined"
                margin="normal"
                value={questionInput}
                onChange={(e) => {
                  setQuestionInput(e.target.value);
                }}
                  onKeyDown={(e) => {
                  // If only Enter is pressed (without Shift or Ctrl)
                  if (e.key === "Enter" && !e.shiftKey && !e.ctrlKey) {
                    e.preventDefault(); // Prevent newline
                    handleSearchDb(); // Trigger submit
                  }
                }}
              />
              <IconButton
                color="primary"
                sx={{ ml: 1, color: "#14bc9a" }}
                onClick={() => {
                  handleSearchDb();
                }}
              >
                {chatLoading ? (
                  <CircularProgress
                    color="success"
                    size={"25px"}
                    sx={{
                      color: "#14bc9a",
                    }}
                  />
                ) : (
                  <SendIcon />
                )}
              </IconButton>
            </Paper>
          </Box>
         
        </Container>
      </Box>
    </MainScreen>
  );
}

const mapStateToProps = (state) => ({
  token: state.auth.token,
});

export default connect(mapStateToProps)(SearchDatabaseDetails);
